import { Box } from "@mui/material";
import { AnimatePresence, motion } from "framer-motion";
import { Page, Workflow } from "components";
import { Utils, useFlow } from "components/workflow";
import { useData, useTheme } from "contexts";
import { Enums } from "utils";

const Profile = () => {
  const { theme } = useTheme();

  const {
    current,
    data,
    direction,
    getVariants,
    step,
    StepComponent,
    updateData,
  } = useFlow<Workflow.Utils.ProfileType>({
    name: Enums.EnumFlow.Profile,
    count: Utils.ProfileSteps.length,
    step: 1,
  });

  if (!current) return <Page.Loader />;

  return (
    <Box
      sx={{
        border: 1,
        overflow: "hidden",
        mt: theme.spacing.md,
        px: theme.spacing.lg,
        pt: theme.spacing.lg,
        pb: theme.spacing.xxl,
        borderRadius: theme.border.radius,
        borderColor: theme.color.primary.accent,
      }}
    >
      <AnimatePresence mode="wait">
        <Box
          component={motion.div}
          key={step}
          variants={getVariants(direction)}
          initial="initial"
          animate="animate"
          exit="exit"
          transition={{ duration: 0.4 }}
        >
          <StepComponent.Component data={data} updateData={updateData} />
        </Box>
      </AnimatePresence>
    </Box>
  );
};

export const Wrapper = () => {
  const { user } = useData();

  if (!user) return <Page.Loader />;

  return (
    <Workflow.Wrapper>
      <Profile />
    </Workflow.Wrapper>
  );
};
